import React from 'react';
import {useField} from 'formik';
import {Input} from '../../../../../../../form/form.jsx';
import {useAddressContext} from '../address-context.js';
import {isolateNumbers} from '../../../../../../../../common/actions.js';

const Index = () => {
  const {prefix} = useAddressContext();

  const [field, meta, helpers] = useField(`${prefix}_index`);
  const {error, touched} = meta;
  const {setValue} = helpers;

  const isValid = !(error && touched);

  return (
    <Input
      {...field}
      placeholder="Индекс"
      inputMode="tel"
      maxLength={6}
      isMin
      isValid={isValid}
      onChange={value => setValue(isolateNumbers(value))}
    />
  );
};

export default Index;
